import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
    Container,
    SuccessContainer,
    SuccessIcon,
    SuccessTitle,
    SuccessMessage,
    Button
} from './styles';

export default function AccountActivation() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const name = searchParams.get('name');

    useEffect(() => {
        // Se não houver o parâmetro name, redireciona para a página de login
        if (!name) {
            navigate('/');
        }
    }, [name, navigate]);

    const handleGoToLogin = () => {
        navigate('/');
    };

    if (!name) {
        return null;
    }

    return (
        <Container>
            <SuccessContainer>
                <SuccessIcon>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </SuccessIcon>
                <SuccessTitle>Conta ativada com sucesso!</SuccessTitle>
                <SuccessMessage>
                    Parabéns, <strong>{name}</strong>! Seu cadastro foi concluído com sucesso.
                    Agora você já pode realizar login na plataforma.
                </SuccessMessage>
                <Button onClick={handleGoToLogin}>
                    Ir para Login
                </Button>
            </SuccessContainer>
        </Container>
    );
}
